import {
  discussion_create_comment_path,
  discussion_reply_input_path,
  discussion_delete_comment_path,
  discussion_list_comments_path
} from '~/routes'

var initTextareas = function(container) {
    var textareas = container.find('textarea')
    // Scale textarea height to content height but only max 400px.
    textareas.off('input propertychange').on('input propertychange', function(e) {
      jQuery(e.currentTarget).css('height', 'auto');
      var height = e.currentTarget.scrollHeight > 400 ? 400 : e.currentTarget.scrollHeight;
      jQuery(e.currentTarget).outerHeight(Math.max(height, 72) + 10);
    }).trigger('input');
  };

  var initEventHandlers = function(discussion, targetType, targetId) {
    var btn = discussion.find('.send-comment-button');
    btn.on('click', function(event) {
      btn.addClass('disabled');
      var body = btn.closest('.media-body').find('textarea').val();
      $.post(discussion_create_comment_path(), { 
        comment: { target_type: targetType, target_id: targetId, body: body }
      }, function(data) {
        discussion.html(data);
        initEventHandlers(discussion, targetType, targetId);
        discussion.data('on-update')();
      }, 'html');
      return false;
    });

    var replyLinks = discussion.find('.reply-link');
    replyLinks.on('click', function(event) {
      var link = $(this);
      link.hide();

      $.get(discussion_reply_input_path(), { 
        target_type: targetType, target_id: targetId, parent_comment_id: $(this).attr('data-comment-id')
      }, function(data) {
        var replySection = link.closest('.media-body').find('.reply-input:first');
        replySection.html(data);
        link.show();
        initTextareas(replySection);
        replySection.find('.send-reply-button').on('click', function() {
          var btn = $(this);
          btn.removeClass('disabled');
          var parentId = btn.attr('data-parent-comment-id');
          var body = btn.closest('.media-body').find('textarea').val();
          $.post(discussion_create_comment_path(), { 
            comment: { target_type: targetType, target_id: targetId, body: body, parent_comment_id: parentId }
          }, function(data) {
            discussion.html(data);
            initEventHandlers(discussion, targetType, targetId);
            discussion.data('on-update')();
          }, 'html');
        });
      }, 'html');
      return false;
    });

    var deleteLinks = discussion.find('.delete-link');
    deleteLinks.on('click', function(event) {
      if(confirm('Are you sure that you want to delete the comment?')) {
        $.post(discussion_delete_comment_path(), { target_type: targetType, target_id: targetId, id: $(this).attr('data-comment-id') }, function(data) {
          discussion.html(data);
          initEventHandlers(discussion, targetType, targetId);

          discussion.data('on-update')();
        }, 'html');
      }
      return false;
    });

    initTextareas(discussion);
  };


  var initDiscussion = function(value) {
    var discussion = $(value);
    var type = discussion.attr('data-target-type');
    var id = discussion.attr('data-target-id');
    var key = discussion.data('update-callback');

    var update = (function() {
      var callbacks = {
        update_message_count: function() {
          var container = discussion.closest('.discussion-container');
          container.find('.message-count').text('(' + discussion.find('.comment').length + ')');
        }
      };
      return callbacks[key] || function() {};
    })();
    discussion.data('on-update', $.proxy(update, discussion));

    $.get(discussion_list_comments_path(), {target_type: type, target_id: id}, function(data) {
      discussion.html(data);
      initEventHandlers(discussion, type, id);

      discussion.data('on-update')();

    }, 'html');
  };


  var initDiscussions = function() {
    var discussions = $('.adalia-discussion');

    $.each(discussions, function(index, value) {
      initDiscussion(value);
    });
  };

  window.initAdaliaDiscussion = initDiscussion;
  window.initAdaliaDiscussions = initDiscussions;

